import React, { useState, useMemo, useEffect } from 'react';
import { Calendar, Clock, AlertTriangle, CheckCircle, DollarSign, Info, ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getUnitAvailability, checkBookingConflicts } from '../../utils/enhancedAvailabilityUtils';
import { SmartAvailabilityCalendar } from '../CheckAvilability/SmartAvailabilityCalendar';
import { FlexibleBookingSelector } from '../CheckAvilability/FlexibleBookingSelector';
import { calculateNights } from '../../utils/paymentUtils';
import { useUnitAvailability } from '../../hooks/useUnitAvailability';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';


export const CheckAvailabilityPage = ({ }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [bookingType, setBookingType] = useState('single');
    const [groupBooking, setGroupBooking] = useState({});
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        checkIn: '',
        checkOut: '',
    });

    const [selectedUnit, setSelectedUnit] = useState('');

    useEffect(() => {
        // add title page
        document.title = t("checkAvailability");
    }, []);

    // Calculate date range for fetching units - next 90 days or based on selected dates
    const fetchDateRange = useMemo(() => {
        // let from = formData.checkIn; 
        // let to = formData.checkOut;
        // let from =  moment(formData.checkIn).utc().format();
        // let to = moment(formData.checkOut).utc().format();
        let from = moment(formData.checkIn).utc(true).set({ hour: 12, minute: 0, second: 0 }).format();
        let to = moment(formData.checkOut).utc(true).set({ hour: 10, minute: 0, second: 0 }).format();
        // if (formData.checkIn && formData.checkOut) {
        //     // If dates are selected, fetch data around those dates (30 days before and after)
        //     from = moment(formData.checkIn).subtract(30, 'days').format('YYYY-MM-DD');
        //     to = moment(formData.checkOut).add(30, 'days').format('YYYY-MM-DD');
        // } else if (formData.checkIn) {
        //     // If only check-in is selected, fetch from check-in to 90 days after
        //     from = moment(formData.checkIn).format('YYYY-MM-DD');
        //     to = moment(formData.checkIn).add(90, 'days').format('YYYY-MM-DD');
        // } else {
        //     // Default: fetch next 90 days
        //     // from = moment().format('YYYY-MM-DD');
        //     // to = moment().add(90, 'days').format('YYYY-MM-DD');
        // }

        return { from, to };
    }, [formData.checkIn, formData.checkOut]);

    // Fetch units and bookings from backend (SINGLE SOURCE OF TRUTH)
    const { availableUnits, unitBookings, isLoading, error } = useUnitAvailability(
        fetchDateRange.from,
        fetchDateRange.to
    );

    // Transform backend units to match the expected format
    const units = useMemo(() => {
        return (availableUnits || []).map(unit => ({
            id: unit._id,
            _id: unit._id,
            type: unit.unitType || unit.type,
            number: unit.unitNo || unit.number,
            price: unit.unitPrice || unit.price || 0,
            name: unit.unitName || unit.name,
            // Include all other properties from backend
            ...unit
        }));
    }, [availableUnits]);

    const handleDateChange = (checkIn, checkOut) => {
        setFormData(prev => ({ ...prev, checkIn, checkOut }));

        // Recalculate amounts when dates change
        if (selectedUnitData && checkIn && checkOut) {
            const newNights = calculateNights(checkIn, checkOut);
            if (newNights > 0) {
                const newOriginalAmount = selectedUnitData.price * newNights;
                const currentDiscountPercentage = formData.discountPercentage || 0;
                const newDiscountAmount = (newOriginalAmount * currentDiscountPercentage) / 100;
                const newTotalAmount = newOriginalAmount - newDiscountAmount;

                setFormData(prev => ({
                    ...prev,
                    originalAmount: newOriginalAmount,
                    discountAmount: newDiscountAmount,
                    totalAmount: newTotalAmount
                }));
            }
        }
    };

    const selectedUnitData = units.find(unit => unit.id === selectedUnit);
    const nights = calculateNights(formData.checkIn, formData.checkOut);

    // Handle unit change
    const handleUnitChange = (unitId) => {
        setSelectedUnit(unitId);
        navigate(`/add-request?unitId=${unitId}&reqFrom=${formData.checkIn}&reqTo=${formData.checkOut}`);
        // const newUnit = units.find(unit => unit.id === unitId);
        // if (newUnit && selectedUnit !== unitId) {
        //     // Store previous total for comparison
        //     // if (selectedUnitData && nights > 0) {
        //         // setPreviousTotalAmount(selectedUnitData.price * nights);
        //     // }
        //     setSelectedUnit(unitId);

        //     // Calculate new amounts when unit changes
        //     // if (nights > 0) {
        //     //     const newOriginalAmount = newUnit.price * nights;
        //     //     const currentDiscountPercentage = formData.discountPercentage || 0;
        //     //     const newDiscountAmount = (newOriginalAmount * currentDiscountPercentage) / 100;
        //     //     const newTotalAmount = newOriginalAmount - newDiscountAmount;

        //     //     setFormData(prev => ({
        //     //         ...prev,
        //     //         originalAmount: newOriginalAmount,
        //     //         discountAmount: newDiscountAmount,
        //     //         totalAmount: newTotalAmount
        //     //     }));
        //     // }
        // } else if (!newUnit) {
        //     setSelectedUnit(unitId);
        //     // setPreviousTotalAmount(undefined);
        // }
    };



    // // Show error state
    // if (error) {
    //     return (
    //         <div className='bg-babyblue-50 big-card container-fluid'>
    //             <div className="flex items-center justify-center min-h-screen">
    //                 <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
    //                     <AlertTriangle className="text-red-600 mx-auto mb-4" size={48} />
    //                     <h3 className="text-lg font-semibold text-red-900 mb-2">{t('errorLoadingUnits') || 'Error Loading Units'}</h3>
    //                     <p className="text-red-700">{error}</p>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <section className='bg-babyblue-50 big-card container-fluid'>
            <div className="header-card d-flex justify-content-between align-items-center">
                <div className="header-title">
                    <h2 className='fw-bolder'>{t("checkAvailability")}</h2>
                </div>
            </div>
            <FlexibleBookingSelector
                units={units}
                unitBookings={unitBookings}
                selectedUnit={selectedUnit}
                selectedCheckIn={formData.checkIn}
                selectedCheckOut={formData.checkOut}
                onUnitChange={handleUnitChange}
                onDateChange={handleDateChange}
                isLoading={isLoading}
            />
        </section>
    );
};